import { useEffect, useState } from 'react';

export default function MyComponent() {
    const [svgContent, setSvgContent] = useState('');

    useEffect(() => {
        fetch('https://img.buymeacoffee.com/button-api/?text=Buy%20us%20a%20dinner&emoji=%F0%9F%A5%99&slug=dinnerfy&button_colour=15bc6e&font_colour=fff&font_family=Poppins&outline_colour=000000&coffee_colour=FFDD00')
            .then(response => response.text())
            .then(data => setSvgContent(data))
            .catch(error => console.error(error));
    }, []);

    return (
        <a href="https://www.buymeacoffee.com/dinnerfy" target={"_blank"}>
        <div dangerouslySetInnerHTML={{ __html: svgContent }} />
        </a>
    );
}
